<template>
  <div class="w-full">
    <div v-if="isTechTeamUser || accountsList.length >= 6" class="w-full">
      <div class="w-full flex items-center justify-center my-10" v-if="!fetchingToken">
        <div class="flex flex-wrap items-center justify-center w-1/2" v-if="isTechTeamUser && !fetchingToken">
          <div class="flex w-full text-gray-400 text-sm py-2 hireful-font-domus">
            Select a system to log in
          </div>
          <autocomplete-tech-user
            :options="accountsList" item-text="organisation_name" item-value="ats_id" label="type at least 3 letters to start searching systems..." @selected="accountSelection" @active="accountSearch"
            >
          </autocomplete-tech-user>
        </div>
      <div class="flex flex-wrap items-center justify-center w-1/2" v-else-if="!fetchingToken">
        <div class="flex w-full text-gray-400 text-sm py-2 hireful-font-domus">
          Select a system to log in
        </div>
        <div class="flex w-full">
          <autocomplete :options="accountsList" item-text="organisation_name" item-value="ats_id" label="type at least 3 letters to start searching systems..." class="" @selected="accountSelection" @active="accountSearch"  />
        </div>
      </div>
      </div>
      <div class="flex w-full items-center justify-center flex-wrap">
        <div class="flex flex-wrap w-full items-center justify-center my-8" v-if="fetchingToken">
          <loader class="mt-8 w-full" />
          <div class="font-bold w-full my-4">
            Logging in
          </div>
        </div>
        <div class="flex w-full items-center justify-center flex-wrap" v-else>
        <button  class="bg-hireful text-white w-1/2 font-bold h-12 rounded-lg text-sm" :class="{ 'bg-hireful': accountSelected, 'bg-gray-200 cursor-not-allowed': !accountSelected }" @click="goToAccount(account)" :disabled="!accountSelected">
          {{btnText}}
        </button>
        </div>
      </div>

      <div class="py-4" v-if="showRecents && !fetchingToken">
        <div class="flex w-full hireful-font-domus text-gray-400 align-center justify-center py-4" v-if="recentAccounts.length">
          Your most recent log ins
        </div>
        <!-- <div class="flex w-full items-center justify-center mb-5 mt-2" v-if="recentAccounts.length">
          <hr class="divider hireful-yellow w-1/4">
        </div> -->
        <template v-for="(client, i) in recentAccounts">
          <div :key="`client-${i}`" class="flex flex-wrap w-full items-center justify-center">
            <div class="flex flex-wrap w-1/2 items-center justify-center my-1 rounded cursor-pointer"  @click="goToAccount(client)" :style="`background-color:${bgColours[i]}`">
              <div class="inline flex-wrap items-left justify-start text-white inline py-2 m-0 px-4 w-10/12">
                <div class="flex w-full text-base hireful-font-semibold font-bold">
                  {{client.organisation_name}}
                </div>
                <div class="flex w-full text-xs italic" v-if="getCompanyTypeText(client.company_type)">
                  {{getCompanyTypeText(client.company_type)}}
                </div>
                <div class="flex w-full text-xs" v-if="client.agency_admin_user">
                {{client.agency_admin_user.first_name}} {{client.agency_admin_user.last_name}}
                </div>
                <div class="flex w-full text-xs">
                  {{isTechTeamUser ? (client.role_type.toLowerCase() === 'technical support user' ? 'Technical User' : client.role_type ) : client.role_type}}
                </div>
              </div>
              <div class="inline text-white text-right justify-end">
                <img src="@/assets/icons/switch.svg" class="cursor-pointer h-7 w-7 mr-2">
              </div>
            </div>
            </div>
        </template>
      </div>
    </div>
    <div v-else class="flex w-full flex-wrap items-center justify-center py-4">
      <div v-for="(client, i) in accountsList" :key="`client-${i}`" class="flex flex-wrap w-full items-center justify-center">
        <div class="flex flex-wrap w-1/2 items-center justify-center my-1 rounded cursor-pointer"  @click="redirectToAts(client.token_id)" :style="`background-color:${bgColours[i]}`">
          <div class="flex flex-wrap items-left justify-start text-white py-2 m-0 px-4 w-10/12">
            <div class="flex w-full text-base hireful-font-semibold font-bold">
              {{client.organisation_name}}
            </div>
            <div class="flex w-full text-xs italic" v-if="getCompanyTypeText(client.company_type)">
              {{getCompanyTypeText(client.company_type)}}
            </div>
            <div class="flex w-full text-xs" v-if="client.agency_admin_user">
                {{client.agency_admin_user.first_name}} {{client.agency_admin_user.last_name}}
            </div>
            <div class="flex w-full text-xs">
              {{isTechTeamUser ? 'Technical User' : client.role_type}}
            </div>
          </div>
          <div class="inline text-white text-right justify-end">
            <img src="@/assets/icons/switch.svg" class="cursor-pointer h-7 w-7 mr-2">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import autocomplete from '@/components/autocomplete'
import loader from '@/components/loader'
import autocompleteTechUser from '@/components/autocompleteTechUser'

export default {
  name: 'selectAccount',
  components: {
    autocomplete,
    loader,
    autocompleteTechUser
  },
  props: {
    accounts: {
      type: Object,
      default: () => {}
    },
    btnText: {
      type: String,
      default: 'Log in'
    }
  },
  data () {
    return {
      account: {},
      accountSelected: false,
      showRecents: true,
      fetchingToken: false,
      bgColours: ['#463E74', '#86C8C9', '#EB9A00', '#D90368', '#40C9A2']
    }
  },
  computed: {
    isTechTeamUser () {
      return this.accounts.is_internal_user || false
    },
    accountsList () {
      const accountsList = this.accounts.accessibleATSList || []
      return accountsList.filter(c => !c.is_disabled).sort((a, b) => a.organisation_name.localeCompare(b.organisation_name))
    },
    recentAccounts () {
      return this.accounts.recentlyVisitedATSList
    }
  },
  methods: {
    accountSelection (account) {
      this.account = account
      this.accountSelected = true
    },
    async goToAccount (account) {
      this.fetchingToken = true
      if (this.accounts.is_internal_user) {
        const tokenResp = await this.getTokenForTechUser(account.ats_id)
        if (tokenResp.token_id) {
          this.redirectToAts(tokenResp.token_id)
        }
      } else {
        const accountObj = this.accountsList.filter(acc => acc.ats_id === account.ats_id)
        if (accountObj.length && accountObj[0].token_id) {
          this.redirectToAts(accountObj[0].token_id)
        } else {
          console.log('Something went wrong while fetcing your login token')
        }
      }
    },
    accountSearch (flag) {
      // this.showRecents = !flag
    }
  }
}
</script>

<style>

</style>
